var s;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Engage = "engage", e.Hide = "hide", e.NoAction = "no-action", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.Login = "login", e.TranslateDocumentBody = "translate-document-body";
})(s || (s = {}));
var n;
(function(e) {
  e.Resend = "resend", e.Signup = "signup", e.Signin = "signin", e.Validation = "validation";
})(n || (n = {}));
var i;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(i || (i = {}));
var t;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand", e.Integrations = "integrations";
})(t || (t = {}));
var o;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(o || (o = {}));
var c;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(c || (c = {}));
var g;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(g || (g = {}));
var u;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered", e.RegisteredAndLogged = "registered", e.NotRegisteredAndNotLogged = "non_registered_nor_logged", e.RegisteredOrLogged = "registered_all", e.RegisteredAndNotLogged = "registered_non_logged", e.NotLogged = "non_registered";
})(u || (u = {}));
var f;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(f || (f = {}));
var l;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(l || (l = {}));
var v;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.SecondaryButton = "secondaryButton", e.Background = "background", e.Overlay = "overlay";
})(v || (v = {}));
var h;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(h || (h = {}));
var p;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(p || (p = {}));
var d;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(d || (d = {}));
var m;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(m || (m = {}));
var _;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(_ || (_ = {}));
var y;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(y || (y = {}));
var r;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(r || (r = {}));
var b;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit", e.LastSearch = "send_to_last_search";
})(b || (b = {}));
var w;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(w || (w = {}));
var X;
(function(e) {
  e.Primary = "primary", e.Secondary = "secondary";
})(X || (X = {}));
var S;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(S || (S = {}));
var k;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(k || (k = {}));
var N;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(N || (N = {}));
var C;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(C || (C = {}));
var a;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(a || (a = {}));
var I;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(I || (I = {}));
var R;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(R || (R = {}));
var x;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})(x || (x = {}));
var B;
(function(e) {
  e.Date = "date", e.Time = "time";
})(B || (B = {}));
var E;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(E || (E = {}));
var U;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(U || (U = {}));
var G;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(G || (G = {}));
var P;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(P || (P = {}));
var D;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(D || (D = {}));
var H;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})(H || (H = {}));
var j;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(j || (j = {}));
var O;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(O || (O = {}));
var W;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(W || (W = {}));
var q;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(q || (q = {}));
var V;
(function(e) {
  e.Bar = "bar", e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.SlideIn = "slide-in", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(V || (V = {}));
var z;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(z || (z = {}));
var F;
(function(e) {
  e.Inline = "inline", e.Overlay = "overlay";
})(F || (F = {}));
const M = {
  [r.NowViewing]: "There are XXXXXX people looking at this hotel right now",
  [r.TodayViewed]: "XXXXXX people have looked at this hotel today",
  [r.BookedToday]: "XXXXXX people have already booked today",
  [r.LastReservation]: "Last reservation was XXXXXX hours ago",
  [r.DiscountToday]: "XXXXXX% discount only today",
  [r.TodaySpecialOffer]: "Today's special offer: XXXXXX"
}, J = {
  [a.None]: "none",
  [a.SubjectToAvailibity]: "Subject to availability",
  [a.WebExclusive]: "Web exclusive",
  [a.OnlyForRegisterdUsers]: "Only for registered users",
  [a.OnlyForSpecificRates]: "Only for specific rates"
};
export {
  s as A,
  _ as B,
  B as C,
  H as D,
  p as F,
  N as L,
  m as M,
  I as P,
  d as R,
  h as T,
  V as a,
  S as b,
  y as c,
  D as d,
  C as e,
  F as f,
  k as g,
  b as h,
  X as i,
  W as j,
  i as k,
  M as l,
  q as m,
  E as n,
  x as o,
  J as p,
  U as q,
  G as r,
  P as s,
  n as t
};
//# sourceMappingURL=maps.ChaVcqWI.js.map
